<template>
    <div class="page-passport">
        <div class="page-box-layout">
            <div class="message">
                <p>Hi,{{ userInfo && userInfo.name }}：</p>
                <p>欢迎加入ShowStart Release</p>
            </div>
            <div class="tips">
                <!-- <p>你可以体验我们的<router-link  to="/manage/album/add">专辑上传功能</router-link>，</p>
                <p>或者，经过以下两步，你就可以进行全球发行了。</p> -->
            </div>

            <div class="entrance-box">
                <div
                    class="entrance-item entrance1"
                    :class="{current: vip.isContractSigned != 1 || vip.isExpired == 1, over: vip.isContractSigned == 1}"
                >
                    <div class="step">No.1</div>
                    <div class="item">
                        <div class="left" v-if="vip.isContractSigned != 1">
                            <router-link :to="`/manage/verify/step${!isVerify ? '1' : '2'}`">
                                <div>立即签约</div>
                            </router-link>
                        </div>
                        <div v-else class="over-left">
                            <div>
                                已签约
                                <router-link to="/manage/contractdetails" v-if="vip">
                                    合同有效期：{{ vip.contractStartTimeStr }} 至 {{ vip.contractEndTimeStr }}
                                </router-link>
                            </div>
                        </div>
                        <div class="right">
                            <p>The identity authentication</p>
                            <div class="name">签约授权合同</div>
                        </div>
                    </div>
                </div>
                <div class="entrance-item entrance2" :class="{current: vip.isContractSigned == 1 && vip.isPaid == 0, over: vip.isPaid == 1}">
                    <div class="step">No.2</div>
                    <div class="item" v-if="vip.isContractSigned == 1">
                        <div class="left" v-if="vip.isPaid == 0">
                            <router-link :to="vip.isContractSigned == 1 && vip.isPaid == 0 ? '/manage/pay' : ''">
                                <p>去付费</p>
                            </router-link>
                        </div>
                        <div v-if="vip.isPaid == 1 && vip.endTimeStr" class="over-left">
                            <el-button
                                v-if="vip.isExpired == 1 && $store.state.userType != 3"
                                class="try-out-btn"
                                @click="$router.push('/manage/pay')"
                            >
                                去续费
                            </el-button>
                            <div>
                                已支付
                                <div v-if="vip.isExpired == 1">
                                    有效期：{{ vip.endTimeStr }}
                                    <span class="color-danger">已失效</span>
                                </div>
                                <div v-else>有效期：{{ vip.endTimeStr }}</div>
                            </div>
                        </div>
                        <div class="right">
                            <p>Pay for global distribution</p>
                            <div class="name">年服务付费</div>
                        </div>
                    </div>
                    <div class="item wait" v-else>
                        <div class="left">
                            <p>年服务付费</p>
                            <p class="big">Pay for global distribution</p>
                        </div>
                    </div>
                </div>
                <!-- <div v-if="$store.state.verify && $store.state.verify.canExperienceRelease" class="try-out">
                    或
                    <el-button type="text" @click="$router.push('/manage/album/list')">免费试用</el-button>
                    发行一次单曲
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    computed: {
        isVerify() {
            return this.$store.state.verify && this.$store.state.verify.isVerify ? true : false;
        },
        vip() {
            const {verify} = this.$store.state;
            const {isContractSigned, isPaid, isExpired, contractStartTimeStr, contractEndTimeStr, endTimeStr} = (verify && verify.vip) || {};
            return {
                isContractSigned: isContractSigned || 0,
                isPaid: isPaid || 0,
                isExpired: isExpired || 0,
                contractStartTimeStr: contractStartTimeStr || '',
                contractEndTimeStr: contractEndTimeStr || '',
                endTimeStr: endTimeStr || '',
            };
        },
        userInfo() {
            return this.$store.state.userInfo;
        },
    },
    mounted() {
        this.$store.dispatch('getUserInfo');
    },
};
</script>

<style lang="scss" scoped>
.page-passport {
    min-height: 100vh;
    display: flex;
    align-items: center;
    color: #fff;
    background: url('~@/assets/img/bg.png') #000 center center no-repeat;
    background-size: cover;
    position: relative;

    .message {
        p {
            font-size: 56px;
            font-weight: bold;
        }
    }

    .tips {
        margin-top: 30px;
        color: #818181;
        line-height: 32px;

        a {
            color: #fff;
        }
    }
}

.entrance-box {
    margin-top: 100px;
    margin-bottom: 100px;
    position: relative;

    &::before {
        content: '';
        position: absolute;
        top: 0px;
        left: 40px;
        width: 1px;
        height: 100%;
        background-image: linear-gradient(to bottom, #979797 0%, #979797 50%, transparent 50%);
        background-size: 1px 5px;
        background-repeat: repeat-y;
    }

    .entrance-item {
        color: rgba(255, 255, 255, 0.7);
        transition: all 0.3s ease-in-out;
        position: relative;
        display: flex;

        .step {
            width: 80px;
            font-size: 18px;
            font-weight: bold;
            line-height: 25px;
            text-align: center;
            padding-top: 33px;
        }

        .item {
            height: 181px;
            display: flex;
            transition: all 0.3s ease-in-out;
            position: relative;
            flex: 1;
            overflow: hidden;

            .left {
                width: 200px;
                padding: 32px 28px;
                font-size: 16px;
                font-weight: 600;
                position: relative;
                transition: all 0.3s ease-in-out;

                a {
                    color: rgba(255, 255, 255, 0.7);
                    display: block;
                    position: relative;

                    &:after {
                        content: '';
                        position: absolute;
                        width: 8px;
                        height: 9px;
                        right: 0px;
                        bottom: 6px;
                        background: url('~@/assets/img/arrow.png') center center no-repeat;
                        background-size: 100%;
                    }
                }
            }

            .right {
                flex: 1;
                padding: 20px 60px;
                text-align: right;
                position: relative;
                z-index: 0;

                p {
                    font-weight: bold;
                    font-size: 70px;
                    position: absolute;
                    bottom: -20px;
                    right: 36px;
                    line-height: 86px;
                    white-space: nowrap;
                    color: #380d8f;
                }

                div.name {
                    position: absolute;
                    right: 50px;
                    bottom: 40px;
                    font-size: 32px;
                    font-weight: 600;
                    color: #a278f7;
                    line-height: 32px;
                }

                a {
                    color: rgba(255, 255, 255, 0.7);
                    font-size: 12px;
                    text-decoration: underline;
                    font-weight: 600;
                }
            }

            &.wait {
                opacity: 0.6;

                .left {
                    width: 100%;
                }

                p {
                    font-size: 18px;
                    font-weight: 600;
                    color: #ffffff;
                    line-height: 25px;

                    &.big {
                        font-size: 32px;
                        font-weight: bold;
                        color: #ffffff;
                        line-height: 46px;
                    }
                }
            }
        }

        &.current {
            color: #fff;

            .item {
                background: #3f109f;

                .left {
                    background: #4b17b6;
                    color: #fff;
                }

                .right {
                    a {
                        color: #fff;
                    }
                }
            }

            &.entrance1 {
                .right {
                    background: url('~@/assets/img/register/arrow1-bg-2.png') right center no-repeat;
                }
            }

            &.entrance2 {
                .right {
                    background: url('~@/assets/img/register/arrow2-bg-2.png') right center no-repeat;
                }
            }
        }

        &.entrance1 {
            z-index: 1;

            .right {
                background: url('~@/assets/img/register/arrow1-bg-1.png') right center no-repeat;
                background-size: contain;
            }
        }

        &.entrance2 {
            .right {
                background: url('~@/assets/img/register/arrow2-bg-1.png') right center no-repeat;
                background-size: contain;
            }
        }

        &.over {
            color: #9895a6;

            .item {
                background: #b0acbc;
            }

            .over-left {
                position: relative;
                padding-left: 130px;
                background: url('~@/assets/img/register/over.png') left bottom no-repeat;
                background-size: 120px;
                color: #fff;
                width: 450px;

                > div {
                    position: absolute;
                    left: 140px;
                    bottom: 40px;
                    white-space: nowrap;
                    z-index: 9;

                    a {
                        display: block;
                        font-size: 12px;
                        margin-top: 8px;
                        color: #fff;
                        text-decoration: underline;
                    }

                    &::after {
                        display: none;
                    }
                }
            }

            .right p {
                color: #b8b4c2;
            }

            .right div.name {
                color: #8b8999;
            }
        }
    }

    .try-out-btn {
        background: #5521e3;
        border-radius: 20px;
        border: 1px solid #5521e3;
        color: #fff;
        padding: 12px 44px;
        margin-top: 50px;
    }

    .try-out {
        text-align: center;
        font-weight: 400;
        color: #ffffff;
        margin-top: 20px;

        .el-button {
            color: #ffffff;
            text-decoration: underline;
        }
    }
}
</style>
